/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{useState as s,useEffect as o}from"react";import{disposables as e}from"../utils/disposables.js";function i(){let[i]=s(e);return o((()=>()=>i.dispose()),[i]),i}export{i as useDisposables};
//# sourceMappingURL=use-disposables.js.map
